<ng-container *ngIf="loading; else content">
  <app-loader text="Моля изчакайте..."></app-loader>
</ng-container>

<ng-template #content>
  <app-modal [padding]="'lg'">

    <app-modal-header [showCloseButton]="true"
                      [title]="'Информация за сигнал'"
                      [centerTitle]="true" (closed)="closeModal()">
    </app-modal-header>
    <div class="card basic-tab-sect">
      <div class="card-body">
        <ul ngbNav #nav="ngbNav" [activeId]="1" class="nav-tabs">
          <li [ngbNavItem]="1">
            <a ngbNavLink>Основна Информация</a>
            <ng-template ngbNavContent>
              <app-modal-body>
                <section class="row">
                  <h4>Подател на сигнал</h4>
                  <div class="col">
                    <div class="row pt-3">
                      <div class="col">
                        <app-label-value-lozenge [label]="'Име'" [value]="signalRequestorNames">
                        </app-label-value-lozenge>
                      </div>
                      <div class="col">
                        <app-label-value-lozenge [label]="'Телефон за връзка'" [value]="phoneNumber">
                        </app-label-value-lozenge>
                      </div>
                      <div class="col">
                        <app-label-value-lozenge [label]="'Имейл адрес'" [value]="emailAddress">
                        </app-label-value-lozenge>
                      </div>
                      <div class="col">
                        <app-label-value-lozenge [label]="'Вид обратна връзка'" [value]="responseType">
                        </app-label-value-lozenge>
                      </div>
                    </div>
                  </div>
                </section>
                <hr class="mt-4 mb-4" />
                <section class="row signal-details-wrapper">
                  <h4>Описание на сигнала</h4>
                  <div class="col">
                    <div class="col mb-4">
                      <app-label-value-lozenge [label]="'Идентификатор'" [value]="signalId">
                      </app-label-value-lozenge>
                    </div>
                    <div class="row pt-3">
                      <div class="col mb-4">
                        <app-label-value-lozenge [label]="'Заглавие'" [value]="signalTitle">
                        </app-label-value-lozenge>
                      </div>
                      <div class="col mb-4">
                        <app-label-value-lozenge [label]="'Дата на регистрация'" [value]="signalDate">
                        </app-label-value-lozenge>
                      </div>
                      <div class="col mb-4">
                        <app-label-value-lozenge [label]="'Тип на аварията'" [value]="emergencyType">
                        </app-label-value-lozenge>
                      </div>
                      <div class="col mb-4">
                        <app-label-value-lozenge [label]="'Статус'" [value]="status">
                        </app-label-value-lozenge>
                      </div>
                      <div class="col-12">
                        <app-label-value-lozenge [label]="'Описание'" [value]="signalDescription">
                        </app-label-value-lozenge>
                      </div>
                    </div>
                  </div>
                </section>
                <ng-container *ngIf="showAttachedMediaSection">
                  <hr class="mt-4 mb-4" />
                  <section class="row">
                    <h4>Прикачени файлове и медия към сигнала</h4>
                    <div class="col">
                      <div class="media-wrapper mt-3">

                      </div>
                    </div>
                  </section>
                </ng-container>
                <hr class="mt-4 mb-4" />
                <section class="row">
                  <h4>Организиране на физическа проверка</h4>
                  <div class="col">
                    <div class="row pt-3">
                      <div class="col mb-4">
                        <app-label-value-lozenge [label]="'Ремонта група'" [value]="workingGroup">
                        </app-label-value-lozenge>
                      </div>
                      <div class="col mb-4">
                        <app-label-value-lozenge [label]="'Мениджър на ремонта група'" [value]="workingGroupManager">
                        </app-label-value-lozenge>
                      </div>
                      <div class="col mb-4">
                        <app-label-value-lozenge [label]="'Дата и час'" [value]="checkoutDate">
                        </app-label-value-lozenge>
                      </div>
                      <div class="col-12">
                        <app-label-value-lozenge [label]="'Допълнително разяснение'" [value]="checkoutNote">
                        </app-label-value-lozenge>
                      </div>
                    </div>
                  </div>
                </section>

                <hr class="mt-4 mb-4" />
                <section class="row">
                  <h4>Финализиране на сигнала</h4>
                  <div class="col">
                    <div class="row pt-3">
                      <div class="col-12">
                        <app-label-value-lozenge [label]="'Финално заключение'" [value]="'n/a'">
                        </app-label-value-lozenge>
                      </div>
                    </div>
                  </div>
                </section>

                <hr class="mt-4 mb-4" />
                <section class="row">
                  <h4>Местоположение на сигнала</h4>
                  <div class="col-12">
                    <div class="map-container-wrapper mb-3">
                      <app-map-location-selector [readonly]="true"
                                                 [location]="incidentLocation"
                                                 [zoom]="16">
                      </app-map-location-selector>
                    </div>
                  </div>
                </section>

              </app-modal-body>

              <app-modal-footer>
                <div class="footer-wrapper">
                  <button class="btn btn-primary" (click)="closeModal()">Затвори</button>
                </div>
              </app-modal-footer>

            </ng-template>
          </li>
          <li [ngbNavItem]="2">
            <a ngbNavLink>История</a>
            <ng-template ngbNavContent>
              <app-general-history [history]="generalHistory"></app-general-history>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-4"></div>
      </div>
    </div>



  </app-modal>
</ng-template>
